<template>
  <DialogContainer
    :isOpen="isOpen"
    :onClose="onClose"
    :isConfirmation="true"
    :maxWidth="'lg'"
  >
    <template v-slot:title>Obliterate queue</template>
    <template v-slot:content>
      <div class="mt-4 text-sm text-left text-gray-500">
        <p>
          This removes
          <span class="font-mono font-medium text-gray-700">{{ name }}</span>
          and every waiting, delayed, completed and failed job in it. It cannot
          be undone.
        </p>
        <p class="mt-2">
          Running jobs are not stopped: while any job is running, the queue is
          paused but not obliterated. Retry once they finish.
        </p>

        <label for="confirm-queue-name" class="block mt-4 text-gray-700">
          Retype the queue name to confirm
        </label>
        <input
          id="confirm-queue-name"
          type="text"
          autocomplete="off"
          v-model="confirmName"
          :placeholder="name"
          class="form-field-no-icon w-full mt-1 outline-none"
        />
      </div>
    </template>
    <template v-slot:buttons>
      <button
        type="button"
        class="button-submit bg-red-600 hover:bg-red-700 sm:ml-3"
        :disabled="!matches || submitting"
        @click="onConfirm"
      >
        Obliterate
      </button>
      <button type="button" class="button-cancel" @click="onClose">
        Cancel
      </button>
    </template>
  </DialogContainer>
</template>

<script>
import { ref } from "vue";
import DialogContainer from "@/components/common/DialogContainer";

export default {
  name: "ObliterateQueueModal",
  components: { DialogContainer },
  props: {
    // Resolves once the obliterate request has finished; the modal stays
    // open (and locked) until then.
    onSubmit: { type: Function, required: true },
  },
  setup() {
    return {
      isOpen: ref(false),
      submitting: ref(false),
      name: ref(""),
      confirmName: ref(""),
    };
  },
  computed: {
    matches() {
      return this.confirmName.trim() === this.name;
    },
  },
  methods: {
    open(name) {
      this.name = name;
      this.confirmName = "";
      this.isOpen = true;
    },
    onClose() {
      if (!this.submitting) {
        this.isOpen = false;
      }
    },
    async onConfirm() {
      if (!this.matches) return;
      this.submitting = true;
      try {
        await this.onSubmit(this.name);
      } finally {
        this.submitting = false;
        this.isOpen = false;
      }
    },
  },
};
</script>
